import { useEffect, useState } from 'react'
import { CurrentSubView } from '../../models/enums'

const useCurrentSubView = (instanceId?: string): number => {
  const [current, setCurrent] = useState<number>(CurrentSubView.none)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_currentSubView', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_currentSubView'))

    return () => {
      document.removeEventListener('retorik_currentSubView', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useCurrentSubView
